import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Colors } from '../../../../assets/styles';

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    textAlign: 'center',
    paddingBottom: 60,
    fontSize: 22,
    height: 45,
    '@media print': {
      marginBottom: '20px',
    },
  },
  content: {
    borderRadius: 4,
    backgroundColor: Colors.White,
    padding: '35px 16px',
    '@media print': {
      paddingBottom: '0px',
    },
  },
  download: {
    width: 950,
    // paddingTop: '20px',
  },
  pdfTitle: {
    paddingBottom: 20,
    display: 'none',
    fontSize: 22,
  },
  pageDivider: {
    margin: '50px 0',
  },
  topMarginPrint: {
    margin: '35px 0',
  },
  completedDate: {
    textAlign: 'right',
    color: Colors.Gray6,
    paddingRight: '0 !important',
    fontSize: 13,
  },
  sectionTitle: {
    color: 'black',
    fontSize: '16px',
    padding:'35px',
    fontWeight: 700,
    '&.download': {
      padding:'25px',
    },
  },
  sectionTitleItalic: {
    color: 'black',
    fontSize: '16px',
    padding:'35px',
    fontWeight: 700,
    '&.download': {
      padding:'25px 35px',
      fontStyle:'italic',
      fontSize: '14px',
    },
  },
   subSectionTitle: {
    color: 'black',
    fontSize: '16px',
    padding:'0px 35px 35px 35px',
    fontWeight: 700,
    '&.download': {
      fontStyle:'italic',
      fontSize: '14px',
    },
  },
}));

export default useStyles;
